import React from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [status, setStatus] = React.useState("loading"); // loading | success | error
  const [msg, setMsg] = React.useState("");

  React.useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Token tidak ditemukan."); return; }
    let cancelled = false;
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        if (cancelled) return;
        setStatus("success");
        setTimeout(() => navigate("/my-bookings", { replace: true }), 2500);
      } catch (e) {
        if (cancelled) return;
        setStatus("error");
        setMsg(e?.response?.data?.detail || "Verifikasi gagal.");
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted/40" data-testid="verify-email-page">
      <Helmet><title>Verifikasi Email — BATIK</title></Helmet>
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-10 shadow-xl text-center">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 text-accent animate-spin mx-auto mb-5" />
            <h1 className="font-serif text-2xl text-primary mb-2">Memverifikasi Email...</h1>
            <p className="text-sm text-muted-foreground">Mohon tunggu sebentar.</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
              <CheckCircle2 className="h-8 w-8 text-emerald-600" />
            </div>
            <h1 className="font-serif text-2xl text-primary mb-2" data-testid="verify-success">Email Berhasil Diverifikasi</h1>
            <p className="text-sm text-muted-foreground mb-6">Akun Anda kini aktif. Mengalihkan ke Dashboard...</p>
            <Link to="/my-bookings" className="text-accent underline text-sm">Ke Dashboard Sekarang</Link>
          </>
        )}
        {status === "error" && (
          <>
            <div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-5">
              <XCircle className="h-8 w-8 text-red-600" />
            </div>
            <h1 className="font-serif text-2xl text-primary mb-2" data-testid="verify-error">Verifikasi Gagal</h1>
            <p className="text-sm text-muted-foreground mb-6">{msg}</p>
            <Link to="/login" className="inline-block py-2.5 px-6 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90">
              Ke Halaman Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
